const getFetchChargingTokensRequestState = (state) => {
  return state.main.chargingTokenState.fetchChargingTokensRequestState
}
const getChargingTokens = (state) => {
  return state.main.chargingTokenState.chargingTokens
}
const getPaginationOffset = (state) => {
  return state.main.chargingTokenState.paginationOffset
}

const getChargingTokenFilter = (state) => {
  return state.main.chargingTokenState.chargingTokenFilter
}
const getEditChargingTokenRequestState = (state) => {
  return state.main.chargingTokenState.editChargingTokenRequestState
}
const getDeleteChargingTokenRequestState = (state) => {
  return state.main.chargingTokenState.deleteChargingTokenRequestState
}
const getCreateChargingTokenRequestState = (state) => {
  return state.main.chargingTokenState.createChargingTokenRequestState
}
const getCreateChargingTokenBulkRequestState = (state) => {
  return state.main.chargingTokenState.createChargingTokenBulkRequestState
}
const getDownloadChargingTokenSampleFileRequestState = (state) => {
  return state.main.chargingTokenState
    .downloadChargingTokenSampleFileRequestState
}
const getChargingTokensCountRequestState = (state) => {
  return state.main.chargingTokenState.getChargingTokensCountRequestState
}
const getChargingTokenCount = (state) => {
  return state.main.chargingTokenState.count
}
const ChargingTokenSelectors = {
  getFetchChargingTokensRequestState,
  getChargingTokens,
  getPaginationOffset,
  getChargingTokenFilter,
  getEditChargingTokenRequestState,
  getDeleteChargingTokenRequestState,
  getCreateChargingTokenRequestState,
  getCreateChargingTokenBulkRequestState,
  getDownloadChargingTokenSampleFileRequestState,
  getChargingTokensCountRequestState,
  getChargingTokenCount,
}

export default ChargingTokenSelectors
